import { RELATIONSHIP_ENGINE_BANNER_ICON_DATA_URL } from './relationshipEngineBannerIcon.constants';

/** Maps sprite `#id` hrefs to raster sources that print reliably. */
const BANNER_ICON_SRC_BY_HREF: Record<string, string> = {
  '#icon_relationship_engine': RELATIONSHIP_ENGINE_BANNER_ICON_DATA_URL,
};

/**
 * Resolves a section banner sprite href to an `<img src>` when print engines cannot paint `<use>`.
 * @param iconHref - Sprite id reference (e.g. `#icon_relationship_engine`).
 * @returns Data URL or undefined when only SVG sprite reference is available.
 */
export const resolveSectionBannerIconSrc = (
  iconHref: string,
): string | undefined => BANNER_ICON_SRC_BY_HREF[iconHref];
